import { useForm } from '@inertiajs/react'

import { TextInput } from '@atoms'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@components/atoms/Accordion'
import Link from '@components/atoms/Link'
import { ConfigurationsLayout } from '@components/configurations/ConfigurationsLayout'
import { SettingsCard } from '@components/configurations/SettingsCard'
import { SettingsForm, textField } from '@components/configurations/SettingsForm'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('configurations.sendgrid')

export type SendgridShowProps = { values: { SENDGRID_API_KEY: string } }

const GUIDES = {
  api_key_steps: {
    signup: 'https://signup.sendgrid.com/',
    login: 'https://app.sendgrid.com/login',
    api_keys: 'https://app.sendgrid.com/settings/api_keys',
    create: null,
    name: null,
    access: null,
    view: null,
    copy: null,
  },
  domain_steps: {
    start: 'https://app.sendgrid.com/settings/sender_auth/domain/create',
    dns_host: null,
    domain: null,
    records: null,
    verify: null,
    wait: null,
  },
}

export default function SendgridShow({ values }: SendgridShowProps) {
  const form = useForm(values)

  return (
    <ConfigurationsLayout>
      <SettingsCard heading={t('heading')}>
        <SettingsForm form={form} action="/app/settings/sendgrid">
          <div className="tw:flex tw:flex-col tw:gap-1">
            <TextInput label={t('api_key')} description={t('api_key_hint')} {...textField(form, 'SENDGRID_API_KEY')} />
            <Link
              href="https://app.sendgrid.com/settings/api_keys"
              target="_blank"
              rank="link"
              size="sm"
              trailingIcon="external-link"
              className="tw:p-0"
            >
              {t('api_keys_link')}
            </Link>
          </div>
        </SettingsForm>
      </SettingsCard>
      <SettingsCard heading={t('help_heading')}>
        <Accordion type="multiple" className="tw:px-5">
          {Object.entries(GUIDES).map(([guide, steps]) => (
            <AccordionItem key={guide} value={guide} className="tw:border-gray-cool-200 tw:last:border-b-0">
              <AccordionTrigger>{t(`${guide}.title`)}</AccordionTrigger>
              <AccordionContent>
                <ol className="tw:m-0 tw:flex tw:list-decimal tw:flex-col tw:gap-1 tw:pl-5 tw:text-gray-cool-700">
                  {Object.entries(steps).map(([step, href]) => (
                    <li key={step}>
                      {href ? (
                        <Link
                          href={href}
                          target="_blank"
                          rank="link"
                          size="sm"
                          trailingIcon="external-link"
                          className="tw:p-0"
                        >
                          {t(`${guide}.${step}`)}
                        </Link>
                      ) : (
                        t(`${guide}.${step}`)
                      )}
                    </li>
                  ))}
                </ol>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </SettingsCard>
    </ConfigurationsLayout>
  )
}
